import FJConfig from '../FJConfig';

export const ANIMATION_STYLE_LIST = [
    {
        src: 'vertical.mp4',
        type: 'vertical',
        name: 'vertical',
        directions: [
            {
                type: 'vertical',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0.1, z: 0 },
                    endPoint: { x: 0, y: -0.1, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0.5, z: 0 },
                    endPoint: { x: 0, y: -0.5, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'horizontal.mp4',
        type: 'horizontal',
        name: 'horizontal',
        directions: [
            {
                type: 'horizontal',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0.1, y: 0, z: 0 },
                    endPoint: { x: -0.1, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0.5, y: 0, z: 0 },
                    endPoint: { x: -0.5, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 4,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'circle.mp4',
        type: 'circle',
        name: 'circle',
        directions: [
            {
                type: 'circle',
                defaultValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.1, y: 0.1, z: 0 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.5, y: 0.1, z: 0 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0, y: 0, z: 0 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'perspective.mp4',
        type: 'perspective',
        name: 'perspective',
        directions: [
            {
                type: 'perspective-horizontal',
                imageType: 'HORIZONTAL',
                defaultValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.1, y: 0.05, z: 0.4 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.4, y: 0.05, z: 0.4 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0, y: 0, z: 0 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'perspective-vertical',
                imageType: 'VERTICAL',
                defaultValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.05, y: 0.1, z: 0.4 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0.05, y: 0.4, z: 0.4 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'CIRCULAR',
                    amplitudePoint: { x: 0, y: 0, z: 0 },
                    phasePoint: { x: 0, y: 0.25, z: 0.25 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: true,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'zoom.mp4',
        type: 'zoom',
        name: 'zoom',
        directions: [
            {
                type: 'zoom',
                imageType: 'CENTER',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: 0, y: 0, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.6 },
                    endPoint: { x: 0, y: 0, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'zoom-horizontal',
                imageType: 'HORIZONTAL',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: -0.1, y: 0, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: -0.4, y: 0, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'zoom-vertical',
                imageType: 'VERTICAL',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: 0, y: -0.1, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: 0, y: -0.4, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'zoom-bevel-angle-up',
                imageType: 'UP',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: 0.1, y: -0.1, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: 0.3, y: -0.3, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'zoom-bevel-angle-down',
                imageType: 'DOWN',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: -0.1, y: 0.1, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: -0.2 },
                    endPoint: { x: -0.3, y: 0.3, z: 0.8 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 8,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: true,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'dolly.mp4',
        type: 'dolly',
        name: 'dolly',
        directions: [
            {
                type: 'dolly',
                imageType: 'CENTER',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'dolly-horizontal',
                imageType: 'HORIZONTAL',

                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: -0.1, y: 0, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: -0.4, y: 0, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'dolly-vertical',
                imageType: 'VERTICAL',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: -0.1, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: -0.4, z: 0.2 },
                    endPoint: { x: 0, y: 0, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'dolly-bevel-angle-down',
                imageType: 'DOWN',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: -0.1, y: -0.1, z: 0.2 },
                    endPoint: { x: 0.1, y: 0.1, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0.3, y: -0.3, z: 0.2 },
                    endPoint: { x: 0.3, y: 0.3, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
            {
                type: 'dolly-bevel-angle-up',
                imageType: 'UP',
                defaultValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0.1, y: 0.1, z: 0.2 },
                    endPoint: { x: -0.1, y: -0.1, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0.3, y: 0.3, z: 0.2 },
                    endPoint: { x: -0.3, y: -0.3, z: -0.8 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'LINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.65,
                    animationDuration: 10,
                    focus: 0.5,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'zoom-left.mp4',
        type: 'zoom-left',
        name: 'zoom-left',
        directions: [
            {
                type: 'zoom-left',
                defaultValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: -0.2, y: -0.1, z: -0.2 },
                    middlePoint: { x: 0, y: 0.1, z: 0.1 },
                    endPoint: { x: 0.2, y: 0, z: 0.4 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: -0.4, y: -0.1, z: -0.3 },
                    middlePoint: { x: 0, y: 0.1, z: 0.1 },
                    endPoint: { x: 0.2, y: 0, z: 0.6 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    middlePoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'zoom-center.mp4',
        type: 'zoom-center',
        name: 'zoom-center',
        directions: [
            {
                type: 'zoom-center',
                defaultValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: 0, y: -0.1, z: -0.2 },
                    middlePoint: { x: 0, y: 0.1, z: 0.2 },
                    endPoint: { x: 0, y: 0.1, z: 0.4 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: 0, y: -0.1, z: -0.4 },
                    middlePoint: { x: 0, y: 0.1, z: 0.2 },
                    endPoint: { x: 0, y: 0.1, z: 0.6 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    middlePoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
    {
        src: 'zoom-right.mp4',
        type: 'zoom-right',
        name: 'zoom-right',
        directions: [
            {
                type: 'zoom-right',
                defaultValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: -0.2, y: -0.1, z: -0.2 },
                    middlePoint: { x: 0, y: 0.1, z: 0.1 },
                    endPoint: { x: 0, y: 0, z: 0.4 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                maxValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: -0.4, y: -0.1, z: -0.3 },
                    middlePoint: { x: 0, y: 0.1, z: 0.1 },
                    endPoint: { x: 0, y: 0, z: 0.6 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
                minValue: {
                    motionType: 'THREEPOINTLINEAR',
                    startPoint: { x: 0, y: 0, z: 0 },
                    middlePoint: { x: 0, y: 0, z: 0 },
                    endPoint: { x: 0, y: 0, z: 0 },
                    amountOfMotion: 0.4,
                    animationDuration: 10,
                    focus: 1,
                    edgeDilation: 0.002,
                    isLoop: false,
                    isReverse: false,
                    isLoopDisabled: false,
                    isReverseDisabled: false,
                },
            },
        ],
    },
];
export const VIDEO_RESOLUTION = [
    { type: '480', price: 1 },
    { type: '720', price: 2 },
    { type: '1080', price: 3 },
];
export const GIF_RESOLUTION = [
    { type: '240', price: 1 },
    { type: '480', price: 2 },
];
export const FORMATE = ['video', 'gif'];
export const QUALITIES = {
    480: {
        low: { bitrate: 2000000, crf: 21 },
        mid: { bitrate: 4000000, crf: 20 },
        high: { bitrate: 6000000, crf: 19 },
    },
    720: {
        low: { bitrate: 4000000, crf: 21 },
        mid: { bitrate: 6000000, crf: 20 },
        high: { bitrate: 8000000, crf: 19 },
    },
    1080: {
        low: { bitrate: 8000000, crf: 21 },
        mid: { bitrate: 10000000, crf: 20 },
        high: { bitrate: 20000000, crf: 19 },
    },
    2160: {
        low: { bitrate: 20000000, crf: 21 },
        mid: { bitrate: 25000000, crf: 20 },
        high: { bitrate: 50000000, crf: 19 },
    },
    default: {
        low: { bitrate: 4000000, crf: 21 },
        mid: { bitrate: 6000000, crf: 20 },
        high: { bitrate: 8000000, crf: 19 },
    },
};
export const PRE_SET_LIST = [
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '01.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '01.png',
            width: 1024,
            height: 1024,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '01-depth-map.png',
            width: 1024,
            height: 1024,
        },
        animationStyle: 'circle',
        directionType: 'circle',
        intensity: 50,
    },
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '02.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '02.png',
            width: 1920,
            height: 1920,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '02-depth-map.png',
            width: 1920,
            height: 1920,
        },
        animationStyle: 'zoom',
        directionType: 'zoom',
        intensity: 50,
    },
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '03.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '03.png',
            width: 1024,
            height: 1024,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '03-depth-map.png',
            width: 1024,
            height: 1024,
        },
        animationStyle: 'horizontal',
        directionType: 'horizontal',
        intensity: 50,
    },
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '04.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '04.png',
            width: 816,
            height: 816,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '04-depth-map.png',
            width: 816,
            height: 816,
        },
        animationStyle: 'zoom',
        directionType: 'zoom',
        intensity: 50,
    },
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '05.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '05.png',
            width: 1024,
            height: 1024,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '05-depth-map.png',
            width: 1024,
            height: 1024,
        },
        animationStyle: 'zoom-center',
        directionType: 'zoom-center',
        intensity: 50,
    },
    {
        videoSrc: FJConfig.imgPath + 'fake3d/preset/' + '06.mp4',
        originImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '06.png',
            width: 1024,
            height: 1024,
        },
        deepMapImage: {
            src: FJConfig.imgPath + 'fake3d/preset/' + '06-depth-map.png',
            width: 1024,
            height: 1024,
        },
        animationStyle: 'perspective',
        directionType: 'perspective-horizontal',
        intensity: 50,
    },
];
